import { Component, OnInit, Host, ViewChild, Input, Output, ElementRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort, MatSlideToggle } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";
import * as moment from 'moment';

import { SharedService } from './../../../services/shared.service';
import { Testata } from '../../../models/Testata';
import { TestataService } from './../../../services/testata.service';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';
import { AppComponent } from './../../../app.component';

@Component({
  selector: 'app-testata-search',
  templateUrl: './testata-search.component.html',
  styleUrls: ['./testata-search.component.css'],
  providers: [TestataService],
  encapsulation: ViewEncapsulation.None
})
export class TestataSearchComponent implements OnInit {
  displayedColumns = ['codice', 'descrizione'];
  database: MatTableCustomDao<Testata> | null;
  dataSource: MatTableCustomDataSource<Testata, MatTableCustomApi<Testata>>;

  printing: boolean = false;
  confirm2remove: boolean = false;
  persisting: boolean = false;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Testata> = new EventEmitter<Testata>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('qjolly') qjolly: ElementRef;

  filter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private router: Router,
    private sharedService: SharedService,
    public service: TestataService,
    public parent: AppComponent) {

      this.sharedService.sharedEmitter.subscribe((o) => {
        console.log('Emitted data', o);

        // ============ AGGIORNAMENTO ROW MatTable ============
        if (o) {
          const _data = this.dataSource.data;
          let wndx = this.dataSource.data.findIndex(c => c.codice == o.codice);
          console.log('MATCH', wndx);
          if (wndx != -1) {
            _data[wndx] = o;
            console.log('MATCH object', _data[wndx]);
          }
          this.dataSource.data = _data;
        }
        // ============ AGGIORNAMENTO ROW MatTable ============
      })
    }

  get filters(): any {
    console.log(this.qjolly.nativeElement.value)
    return {
      jolly: this.qjolly.nativeElement.value
    }
  }

  onFilterKeypress(event: KeyboardEvent) {
    if (event.keyCode == 13) {
       this.filter.emit(this.filters);
    }
  }

  add() {
    this.router.navigate(['/testata']);
  }

  edit() {
    this.router.navigate(['/testata/' + this.service.selected]);
  }

  remove() {
    if (this.service.selected) {
      this.persisting = true;
      this.parent.addToast('', 'eliminazione in corso...', ((wid) => {
        setTimeout(() => {
          let item2remove = new Testata({
            codice: this.service.selected
          })
          this.service.remove(item2remove).subscribe((res) => {
            console.log(res)
            if (res.success) {
              this.confirm2remove = false;
            }
            this.parent.clearToast(wid);
            this.filter.emit(this.filters);
            this.persisting = false;
            this.parent.operSnackBar(res.success, res.success ? 'eliminazione completata' : res.err)
          })
        }, 1000);
      }))
    }
  }

  choose() {
    console.log('chooooose', this.service.selected)
    this.service.getTestata(this.service.selected).subscribe(result => {
      console.log(result)
      if (result.success && result.testata) {
        this.notify.emit(new Testata(result.testata));
      }
    })
  }

  download() {
    this.parent.addToast('', 'estrazione in corso', ((wid) => {
      setTimeout(() => {
        this.service.downloadFile(this.filters).subscribe(data => {
          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'testate' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');
          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
        })
      }, 1000);
    }))
  }

  highlight(row) {
    this.service.selected = row.codice;
  }

  ngOnInit() {
    this.database = new MatTableCustomDao(this.service);
    this.dataSource = new MatTableCustomDataSource(
      this.database!,
      this.paginator,
      this.sort,
      this.filter,
      false);
  }

  getTitle(): string {
    return "testate";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/testata/testata-search/testata-search.component.ts